import * as React from "react";
const SvgRodent = props => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" {...props}><g id="Rat_1_"><circle style={{
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }} cx={256} cy={467} r={30} /><circle style={{
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeMiterlimit: 10
    }} cx={256} cy={467} r={30} /><path style={{
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeMiterlimit: 10
    }} d="M117.54,224.972&#10;&#9;&#9;C60.686,223.665,15,177.168,15,120C15,62.01,62.01,15,120,15s105,47.01,105,105c0,6.259-0.548,12.391-1.598,18.349" /><path style={{
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeMiterlimit: 10
    }} d="M288.598,138.349&#10;&#9;&#9;C287.548,132.391,287,126.259,287,120c0-57.99,47.01-105,105-105s105,47.01,105,105c0,57.168-45.686,103.665-102.54,104.972" /><path style={{
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeMiterlimit: 10
    }} d="M278.378,486.981l89.479-100.147&#10;&#9;&#9;C391.568,360.296,406,325.3,406,287c0-82.705-67.295-150-150-150s-150,67.295-150,150c0,38.3,14.432,73.296,38.143,99.834&#10;&#9;&#9;l89.479,100.147" /><line style={{
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }} x1={339.39} y1={418.695} x2={406} y2={452} /><line style={{
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }} x1={375.926} y1={377} x2={436} y2={377} /><line style={{
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }} x1={172.61} y1={418.695} x2={106} y2={452} /><line style={{
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }} x1={136.074} y1={377} x2={76} y2={377} /><line style={{
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }} x1={316} y1={317} x2={316} y2={317} /><line style={{
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }} x1={196} y1={317} x2={196} y2={317} /></g></svg>;
export default SvgRodent;